applications.service('PdfService', function(RestService){
    
    return {
        
        getPdf: function(file) {
            return RestService.get('/api/TaxPdf?f='+file);
        }
      
    }
});